export const COLUMN_CHANGE_TYPE = {
   ADD: 0,
   POST_ADD: 1,
   EDIT: 2,
   DELETE: 3
};



// WEBPACK FOOTER //
// ./src/constants/ColumnActions.js